<app-header></app-header>
<div class="home-main">
  <div class="sidebar">
    <app-sidebar
      (headingEvent)="receiveHeading($event)"
      (toggleSidebarEvent)="receiveSidebarEvent($event)"
    />
  </div>
  <div
    class="patent"
    style="background-color: #f2f6ff; padding-bottom: 70px"
    [ngClass]="toggle_sidebar ? 'main_content_2' : 'main_content_1'"
  >
    <div class="news-section">
      <!-- <app-ipd-updates-header (currCountry)="getCurrentCuntry($event)"></app-ipd-updates-header> -->
      <app-news-banner
        [data]="newsBannerData"
        [showNews]="showNews"
        *ngIf="newsBannerData.length"
      ></app-news-banner>
      <app-recent-news
        [data]="recentNewsList"
        *ngIf="recentNewsList.length"
      ></app-recent-news>
      <app-news-category
        [data]="newsCategoryData"
        [showNews]="showCategory"
        [showAllButton]="showAllButton"
        *ngIf="showCategory"
      ></app-news-category>
    </div>
  </div>
</div>
<app-footer></app-footer>
